<template>
  <!-- 增加修改 -->
  <a-modal :title="formTitle || '新增用户'" v-model:visible="visible" @cancel="onClose" :width="1100" :maskClosable="false"
    :keyboard="false" :destroyOnClose="true" :footer="null" class="create-form-modal">
    <a-form ref="formRef" :model="form" :rules="rules" :label-col="{ flex: '0 0 150px' }"
      :wrapper-col="{ flex: '1 1 auto' }" class="two-column-form">
      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="员工姓名" name="nickName">
            <a-input v-model:value="form.nickName" placeholder="请输入" :maxLength="30" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="员工角色" name="roleIds">
            <a-select v-model:value="form.roleIds" placeholder="请选择" @change="handleRoleChange">
              <a-select-option v-for="(d, index) in roleOptions" :key="index" :value="d.id">
                {{ d.roleName }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="性别" name="sex">
            <a-select v-if="form.rortraitUrl && form.sex !== 1 && form.sex !== 2" v-model:value="form.sex"
              placeholder="请选择性别" allow-clear style="width: 100%">
              <a-select-option :value="1">男</a-select-option>
              <a-select-option :value="2">女</a-select-option>
              <a-select-option :value="0">保密</a-select-option>
            </a-select>
            <a-input v-else :value="sexDisplayText" disabled placeholder="请上传人像面自动识别" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="民族" name="nationality">
            <a-input v-model:value="form.nationality" disabled placeholder="请上传人像面自动识别" />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="出生年月日" name="birthDate">
            <a-date-picker v-model:value="form.birthDate" style="width: 100%" disabled placeholder="请上传人像面自动识别"
              format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" allow-clear />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="身份证号" name="idNumber">
            <a-input v-model:value="form.idNumber" disabled placeholder="请上传人像面自动识别" />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="身份证有效期开始" name="cardStartTime">
            <a-date-picker v-model:value="form.cardStartTime"
              :disabled="hasIdCardFromApi || !hasIdCardRecognized || (hasIdCardRecognized && !!form.cardStartTime)"
              style="width: 100%" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" placeholder="请上传国徽面自动识别" allow-clear />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="身份证有效期截止" name="cardEndTime">
            <a-date-picker v-model:value="form.cardEndTime"
              :disabled="hasIdCardFromApi || !hasIdCardRecognized || (hasIdCardRecognized && !!form.cardEndTime)"
              style="width: 100%" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" placeholder="请上传国徽面自动识别" allow-clear />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="用户手机号" name="phoneNumber">
            <a-input v-model:value="form.phoneNumber" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="电子邮箱" name="email">
            <a-input v-model:value="form.email" placeholder="请输入" />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="入职时间" name="entryTime">
            <a-date-picker v-model:value="form.entryTime" style="width: 100%" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"
              placeholder="请选择日期" allow-clear />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="离职时间" name="departTime">
            <a-date-picker v-model:value="form.departTime" style="width: 100%" format="YYYY-MM-DD"
              valueFormat="YYYY-MM-DD" placeholder="请选择日期" allow-clear :disabled-date="disabledDepartDate"
              :disabled="!isResignedStatus" />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="机动人才编号" name="certificateCode">
            <a-input v-model:value="form.certificateCode" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="当前状态" name="userStatus">
            <a-select v-model:value="form.userStatus" @change="handleUserStatusChange">
              <a-select-option :key="item.dictValue" v-for="(item, index) in currentStatusOptions">{{ item.dictLabel
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="用户授权平台" name="loginPlatform">
            <a-select v-model:value="form.loginPlatform">
              <a-select-option :key="item.dictValue" v-for="(item, index) in loginPlatformOptions">{{ item.dictLabel
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="公司授权" name="deptId">
            <a-tree-select v-model:value="form.deptId" style="width: 100%"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="deptOptions" placeholder="请选择"
              :replaceFields="replaceFields" tree-default-expand-all>
            </a-tree-select>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="项目授权" name="projectCodes">
            <a-select :value="isAllProjectSelected ? '0' : selectedProjects" placeholder="请选择项目" style="width: 100%"
              :mode="isAllProjectSelected ? undefined : 'multiple'" :disabled="!isManagementRole"
              @change="handleProjectChange">
              <a-select-option value="0">全部项目</a-select-option>
              <a-select-option v-for="project in projectList" :key="project.id" :value="project.id">
                {{ project.chineseName || project.projectCode }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="所在项目" name="projectId">
            <a-select v-model:value="form.projectId" show-search :filter-option="filterProjectOption"
              placeholder="请选择所在项目" style="width: 100%" allow-clear :disabled="isManagementRole"
              @change="handleProjectIdChange">
              <a-select-option v-for="project in projectList" :key="project.id" :value="project.id">
                {{ project.chineseName || project.projectCode }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12" v-if="form.id == undefined">
        <a-col :span="12">
          <a-form-item label="用户登录名" name="userName">
            <a-input v-model:value="form.userName" placeholder="请输入" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="用户密码" name="password">
            <a-input-password v-model:value="form.password" placeholder="请输入" :maxLength="20" />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <a-form-item label="项目排班" name="attendadceId">
            <a-select v-model:value="form.attendadceId" placeholder="请先选择所在项目" style="width: 100%"
              :disabled="!isAttendanceRole || !form.projectId" allow-clear :loading="attendanceLoading">
              <a-select-option v-for="item in attendanceOptions" :key="item.id" :value="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
        </a-col>
      </a-row>

      <a-form-item label="证件上传">
        <a-row :gutter="16" justify="center" class="upload-row">
          <a-col :span="8">
            <a-form-item name="rortraitUrl" :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }">
              <div class="upload-item">
                <div class="upload-label">身份证照片(人像面)</div>
                <file-upload :value="form.rortraitUrl" type="image" :count="1" @change="handleRortraitUrlChange" />
              </div>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item name="emblemUrl" :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }">
              <div class="upload-item">
                <div class="upload-label">身份证照片(国徽面)</div>
                <file-upload :value="form.emblemUrl" type="image" :count="1" @change="handleEmblemUrlChange" />
              </div>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item name="certificateUrl" :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }">
              <div class="upload-item">
                <div class="upload-label">机动人才证书</div>
                <file-upload :value="form.certificateUrl" type="image" :count="3" field-name="certificateUrl"
                  @change="handleCertificateUrlChange" />
              </div>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form-item>
      <!-- 状态字段隐藏，但保留在表单中以便提交时包含 -->
      <!-- <a-form-item label="状态" name="status" v-show="false">
        <a-radio-group v-model:value="form.status" button-style="solid">
          <a-radio-button
            v-for="(d, index) in statusOptions"
            :key="index"
            :value="parseInt(d.value)"
            >{{ d.label }}</a-radio-button
          >
        </a-radio-group>
      </a-form-item> -->

      <div class="bottom-control">
        <a-space>
          <a-button @click="cancel" class="cancel-btn"> 取消 </a-button>
          <a-button type="primary" :loading="submitLoading" @click="submitForm" class="save-btn">
            保存
          </a-button>
        </a-space>
      </div>
    </a-form>
  </a-modal>
</template>

<!-- script部分保持不变 -->
<script setup>
import { ref, reactive, computed, onMounted, nextTick, watch } from 'vue'
import { useStore } from 'vuex'
import { message } from 'ant-design-vue'
import { $emit } from '../../../../utils/gogocodeTransfer'
import { getUser, getProjectUser, addUser, updateUser } from '@/api/system/user'
import { getInfo } from '@/api/login'
import { listAttendance } from '@/api/system/attendance'
import { baiduVerification } from '@/api/system/config'
import { getConfigKey } from '@/api/system/config'
import moment from 'moment'

const props = defineProps({
  deptOptions: {
    type: Array,
    required: true,
  },
  loginPlatformOptions: {
    type: Array,
    required: true,
  },
  currentStatusOptions: {
    type: Array,
    required: true,
  },
  sexOptions: {
    type: Array,
    required: true,
  },
})

const emit = defineEmits(['select-tree', 'ok', 'close'])
const store = useStore()

const formRef = ref(null)
const statusOptions = ref([
  { value: 0, label: '禁用' },
  { value: 1, label: '启用' },
])
const submitLoading = ref(false)
const replaceFields = {
  children: 'children',
  title: 'label',
  key: 'id',
  value: 'id',
}
const postOptions = ref([])
const roleOptions = ref([])
const projectList = ref([])
const attendanceOptions = ref([])
const attendanceLoading = ref(false)
const isAllProjectSelected = ref(false)
const selectedProjects = ref([])
const initPassword = ref(undefined)
const formTitle = ref('')
const visible = ref(false)
const hasIdCardRecognized = ref(false) // 标记是否已经进行过身份证识别
const hasIdCardFromApi = ref(false) // 标记身份证有效期是否来自接口（编辑模式）

// 表单参数
const form = reactive({
  id: undefined,
  deptId: 0,
  userName: undefined,
  nickName: undefined,
  password: undefined,
  phoneNumber: undefined,
  email: undefined,
  nationality: undefined,
  birthDate: undefined,
  idNumber: undefined,
  cardStartTime: undefined,
  cardEndTime: undefined,
  entryTime: undefined,
  departTime: undefined,
  certificateCode: undefined,
  userStatus: undefined,
  loginPlatform: undefined,
  projectCodes: undefined,
  projectId: undefined,
  attendadceId: undefined,
  rortraitUrl: undefined,
  emblemUrl: undefined,
  certificateUrl: undefined,
  sex: undefined,
  status: 1,
  remark: undefined,
  postIds: '',
  roleIds: '',
})

// 离职时间验证器
let validateDepartTime = null

const rules = reactive({
  userName: [
    { required: true, message: '用户名不能为空', trigger: 'blur' },
  ],
  nickName: [
    { required: true, message: '用户昵称不能为空', trigger: 'blur' },
  ],
  roleIds: [
    { required: true, message: '员工角色不能为空', trigger: 'change' },
  ],
  // deptId: [
  //   { required: true, message: '部门不能为空', trigger: 'change' },
  // ],
  password: [
    { required: true, message: '密码不能为空', trigger: 'blur' },
    {
      min: 5,
      max: 20,
      message: '用户密码长度必须介于 5 和 20 之间',
      trigger: 'blur',
    },
  ],
  email: [
    {
      type: 'email',
      message: '请正确填写邮箱地址',
      trigger: ['blur', 'change'],
    },
  ],
  phoneNumber: [
    { required: true, message: '手机号不能为空', trigger: 'blur' },
    {
      pattern: /^1[3-9]\d{9}$/,
      message: '请输入正确的手机号码',
      trigger: ['blur', 'change'],
    },
  ],
  // loginPlatform: [
  //   {
  //     required: true,
  //     message: '用户授权平台不能为空',
  //     trigger: 'change',
  //   },
  // ],
  userStatus: [
    { required: true, message: '当前状态不能为空', trigger: 'change' },
  ],
  departTime: [
    {
      validator: (rule, value, callback) => {
        if (validateDepartTime) {
          validateDepartTime(rule, value, callback)
        } else {
          callback()
        }
      },
      trigger: ['blur', 'change'],
    },
  ],
  projectCodes: [
    {
      validator: (rule, value, callback) => {
        if (isManagementRole.value) {
          if (
            !value ||
            value === '' ||
            (isAllProjectSelected.value === false &&
              (!selectedProjects.value ||
                selectedProjects.value.length === 0))
          ) {
            callback(new Error('项目授权不能为空'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      },
      trigger: ['blur', 'change'],
    },
  ],
  projectId: [
    {
      validator: (rule, value, callback) => {
        if (isAttendanceRole.value && (value === undefined || value === null || value === '')) {
          callback(new Error('项目主管和保洁员工必须选择所在项目'))
        } else {
          callback()
        }
      },
      trigger: ['blur', 'change'],
    },
  ],
})

// 初始化离职时间验证器
validateDepartTime = (rule, value, callback) => {
  if (!value) {
    callback()
    return
  }
  if (!form.entryTime) {
    callback()
    return
  }
  const entryTime = new Date(form.entryTime)
  const departTime = new Date(value)
  if (departTime < entryTime) {
    callback(new Error('离职时间不能早于入职时间'))
  } else {
    callback()
  }
}

const isManagementRole = computed(() => {
  if (
    !form.roleIds ||
    !roleOptions.value ||
    roleOptions.value.length === 0
  ) {
    return false
  }
  const selectedRole = roleOptions.value.find(
    (role) => role.id === form.roleIds
  )
  if (!selectedRole) {
    return false
  }
  const roleName = selectedRole.roleName || ''
  return roleName === '管理层' || roleName === '营运经理'
})

const isAttendanceRole = computed(() => {
  if (
    !form.roleIds ||
    !roleOptions.value ||
    roleOptions.value.length === 0
  ) {
    return false
  }
  const selectedRole = roleOptions.value.find(
    (role) => role.id === form.roleIds
  )
  if (!selectedRole) {
    return false
  }
  const roleName = selectedRole.roleName || ''
  return roleName === '项目主管' || roleName === '保洁员工'
})

const isResignedStatus = computed(() => form.userStatus === '0' || form.userStatus === 0)

const handleUserStatusChange = (status) => {
  if (status === '0' || status === 0) {
    if (!form.departTime) {
      form.departTime = moment().format('YYYY-MM-DD')
    }
  } else if (status === '1' || status === 1) {
    form.departTime = undefined
  }
}

const sexDisplayText = computed(() => {
  if (form.sex === undefined || form.sex === null) {
    return ''
  }
  // 直接根据 form.sex 的值返回对应的文本，不依赖 props.sexOptions
  if (form.sex === 1) {
    return '男'
  } else if (form.sex === 2) {
    return '女'
  } else if (form.sex === 0) {
    return '保密'
  }
  // 如果 props.sexOptions 存在，尝试从选项中查找
  if (props.sexOptions && props.sexOptions.length > 0) {
    const sexOption = props.sexOptions.find(
      (option) => parseInt(option.value) === parseInt(form.sex)
    )
    if (sexOption) {
      return sexOption.label
    }
  }
  return ''
})

// 判断是否应该显示可编辑的性别选择框
// 当已上传人像面且未识别到明确的性别（不是1或2）时，返回true，显示select
const showSexSelect = computed(() => {
  // 如果还没有上传人像面，返回 false，显示禁用的 input
  if (!form.rortraitUrl) {
    return false
  }
  // 如果识别到了明确的性别（1-男 或 2-女），返回 false，显示禁用的 input
  const sexValue = form.sex
  // 只有识别到明确的性别值（1或2）才禁用，其他所有情况都允许选择
  if (sexValue === 1 || sexValue === 2) {
    return false
  }
  // 其他情况（undefined、null、0、''、NaN 等），返回 true，显示可编辑的 select
  return true
})


// 方法
const onClose = () => {
  console.log('onClose 被调用')
  visible.value = false
  // 触发关闭事件，通知父组件刷新表格
  emit('close')
}

// 取消按钮
const cancel = () => {
  visible.value = false
  reset()
  // 触发关闭事件，通知父组件刷新表格
  emit('close')
}

// 表单重置
const reset = () => {
  Object.assign(form, {
    id: undefined,
    deptId: undefined,
    userName: undefined,
    nickName: undefined,
    password: undefined,
    phoneNumber: undefined,
    email: undefined,
    nationality: undefined,
    birthDate: undefined,
    idNumber: undefined,
    cardStartTime: undefined,
    cardEndTime: undefined,
    entryTime: undefined,
    departTime: undefined,
    certificateCode: undefined,
    userStatus: undefined,
    loginPlatform: undefined,
    projectCodes: undefined,
    projectId: undefined,
    attendadceId: undefined,
    rortraitUrl: undefined,
    emblemUrl: undefined,
    certificateUrl: undefined,
    sex: undefined,
    status: 1,
    remark: undefined,
    postIds: '',
    roleIds: '',
  })
  selectedProjects.value = []
  attendanceOptions.value = []
  hasIdCardRecognized.value = false // 重置识别标记
  hasIdCardFromApi.value = false // 重置接口标记
  attendanceLoading.value = false
  getProjectList()
  isAllProjectSelected.value = false
}

const handleRoleChange = () => {
  if (isManagementRole.value) {
    form.projectId = undefined
    nextTick(() => {
      if (formRef.value) {
        formRef.value.validateFields(['projectCodes'])
      }
    })
  } else {
    form.projectCodes = undefined
    isAllProjectSelected.value = false
    selectedProjects.value = []
    nextTick(() => {
      if (formRef.value) {
        formRef.value.clearValidate('projectCodes')
      }
    })
  }
  if (!isAttendanceRole.value) {
    form.attendadceId = undefined
  }
  nextTick(() => {
    if (formRef.value) {
      if (isAttendanceRole.value) {
        formRef.value.validateFields(['projectId'])
      } else {
        formRef.value.clearValidate(['projectId'])
      }
    }
  })
  loadAttendanceOptions()
}

const getProjectList = () => {
  getInfo()
    .then((res) => {
      if (res.success && res.data) {
        const projectInfoList = res.data.projectInfoList || []
        projectList.value = Array.isArray(projectInfoList)
          ? projectInfoList
          : []
      } else {
        projectList.value = []
      }
    })
    .catch(() => {
      projectList.value = []
    })
}

const filterProjectOption = (input, option) => {
  if (!input) return true
  const value = option.value
  const project = projectList.value.find((p) => p.id === value)
  if (project) {
    const searchText = input.toLowerCase()
    const chineseName = (project.chineseName || '').toLowerCase()
    const projectCode = (project.projectCode || '').toLowerCase()
    return (
      chineseName.indexOf(searchText) >= 0 ||
      projectCode.indexOf(searchText) >= 0
    )
  }
  return false
}

const handleProjectChange = (value) => {
  if (value === '0' || (Array.isArray(value) && value.includes('0'))) {
    isAllProjectSelected.value = true
    selectedProjects.value = []
    form.projectCodes = '0'
  } else {
    isAllProjectSelected.value = false
    if (Array.isArray(value)) {
      selectedProjects.value = value.filter(
        (v) => v !== '0' && v !== undefined && v !== null
      )
      form.projectCodes = selectedProjects.value.join(',')
    } else {
      selectedProjects.value = value ? [value] : []
      form.projectCodes = selectedProjects.value.join(',')
    }
  }
}

const handleProjectIdChange = () => {
  loadAttendanceOptions()
}

const loadAttendanceOptions = () => {
  if (!isAttendanceRole.value || !form.projectId) {
    attendanceOptions.value = []
    if (!isAttendanceRole.value) {
      form.attendadceId = undefined
    }
    return
  }
  attendanceLoading.value = true
  listAttendance({
    projectId: form.projectId,
    status: 1,
  })
    .then((res) => {
      const list = Array.isArray(res.data) ? res.data : []
      attendanceOptions.value = list.map((item) => ({
        id: item.id,
        name: item.name,
      }))
      if (
        form.attendadceId !== undefined &&
        form.attendadceId !== null
      ) {
        const currentId = form.attendadceId
        const exists = attendanceOptions.value.some(
          (option) => option.id == currentId
        )
        if (!exists) {
          form.attendadceId = undefined
        } else {
          form.attendadceId = currentId
        }
      }
    })
    .finally(() => {
      attendanceLoading.value = false
    })
}

const handleRortraitUrlChange = (url) => {
  form.rortraitUrl = url
  if (url) {
    // 上传人像面时，立即标记已进行身份证识别，允许用户手动选择性别
    hasIdCardRecognized.value = true
    // 重置性别为 undefined，等待识别结果
    form.sex = undefined
    callBaiduIdCardRecognition(url, 'front')
  } else {
    form.nickName = undefined
    form.nationality = undefined
    form.birthDate = undefined
    form.idNumber = undefined
    form.sex = undefined
    hasIdCardRecognized.value = false // 清除人像面时，重置识别标记
  }
}

const callBaiduIdCardRecognition = (imageUrl, idCardSide) => {
  const loading = message.loading('正在识别身份证信息...', 0)

  // 识别前，如果是人像面，先重置性别为 undefined，以便判断是否识别到性别
  if (idCardSide === 'front') {
    form.sex = undefined
  }

  baiduVerification({
    image: imageUrl,
    idCardSide: idCardSide || 'front',
  })
    .then((res) => {
      loading()
      if (res.success && res.data) {
        const result = res.data
        const wordsResult = result.wordsResult

        if (!wordsResult) {
          message.warning('未能识别到身份证信息', 3)
          // 识别失败，标记已识别但性别未识别到，允许用户手动选择
          hasIdCardRecognized.value = true
          if (idCardSide === 'front') {
            form.sex = undefined
          }
          return
        }

        if (idCardSide === 'front') {
          if (wordsResult.name && wordsResult.name.words) {
            form.nickName = wordsResult.name.words
          }
          if (wordsResult.nation && wordsResult.nation.words) {
            form.nationality = wordsResult.nation.words
          }
          if (wordsResult.birth && wordsResult.birth.words) {
            const birthStr = wordsResult.birth.words
            let birthDate = null
            if (birthStr.length === 8 && /^\d{8}$/.test(birthStr)) {
              birthDate =
                birthStr.substring(0, 4) +
                '-' +
                birthStr.substring(4, 6) +
                '-' +
                birthStr.substring(6, 8)
            } else if (
              birthStr.includes('年') &&
              birthStr.includes('月') &&
              birthStr.includes('日')
            ) {
              const match = birthStr.match(
                /(\d{4})年(\d{1,2})月(\d{1,2})日/
              )
              if (match) {
                const year = match[1]
                const month = match[2].padStart(2, '0')
                const day = match[3].padStart(2, '0')
                birthDate = `${year}-${month}-${day}`
              }
            }
            if (birthDate) {
              form.birthDate = birthDate
            }
          }
          if (wordsResult.idNumber && wordsResult.idNumber.words) {
            form.idNumber = wordsResult.idNumber.words
          }
          // 处理性别识别
          if (wordsResult.gender && wordsResult.gender.words) {
            const genderStr = wordsResult.gender.words.trim()
            console.log('识别到的性别值:', genderStr)
            // 支持多种格式的性别值判断
            if (genderStr.includes('男') || genderStr === 'M' || genderStr === 'm' || genderStr.toLowerCase() === 'male') {
              form.sex = 1
              console.log('设置性别为: 1 (男)')
            } else if (genderStr.includes('女') || genderStr === 'F' || genderStr === 'f' || genderStr.toLowerCase() === 'female') {
              form.sex = 2
              console.log('设置性别为: 2 (女)')
            } else {
              // 如果识别到性别但值不是"男"或"女"，设置为 undefined，让用户选择
              console.log('性别值无法识别，设置为 undefined，允许用户手动选择')
              form.sex = undefined
            }
          } else {
            // 如果没有识别到性别字段，明确设置为 undefined，让用户选择
            console.log('未识别到性别字段，设置为 undefined，允许用户手动选择')
            form.sex = undefined
          }
        } else if (idCardSide === 'back') {
          if (wordsResult.issueDate && wordsResult.issueDate.words) {
            const issueDateStr = wordsResult.issueDate.words
            let issueDate = null
            if (issueDateStr.length === 8 && /^\d{8}$/.test(issueDateStr)) {
              issueDate =
                issueDateStr.substring(0, 4) +
                '-' +
                issueDateStr.substring(4, 6) +
                '-' +
                issueDateStr.substring(6, 8)
            } else if (
              issueDateStr.includes('年') &&
              issueDateStr.includes('月') &&
              issueDateStr.includes('日')
            ) {
              const match = issueDateStr.match(
                /(\d{4})年(\d{1,2})月(\d{1,2})日/
              )
              if (match) {
                const year = match[1]
                const month = match[2].padStart(2, '0')
                const day = match[3].padStart(2, '0')
                issueDate = `${year}-${month}-${day}`
              }
            }
            if (issueDate) {
              form.cardStartTime = issueDate
            }
          }
          if (wordsResult.expiryDate && wordsResult.expiryDate.words) {
            const expiryDateStr = wordsResult.expiryDate.words
            let expiryDate = null
            if (
              expiryDateStr.length === 8 &&
              /^\d{8}$/.test(expiryDateStr)
            ) {
              expiryDate =
                expiryDateStr.substring(0, 4) +
                '-' +
                expiryDateStr.substring(4, 6) +
                '-' +
                expiryDateStr.substring(6, 8)
            } else if (
              expiryDateStr.includes('年') &&
              expiryDateStr.includes('月') &&
              expiryDateStr.includes('日')
            ) {
              const match = expiryDateStr.match(
                /(\d{4})年(\d{1,2})月(\d{1,2})日/
              )
              if (match) {
                const year = match[1]
                const month = match[2].padStart(2, '0')
                const day = match[3].padStart(2, '0')
                expiryDate = `${year}-${month}-${day}`
              }
            }
            if (expiryDate) {
              form.cardEndTime = expiryDate
            }
          }
        }

        // 识别成功后，标记已进行身份证识别
        hasIdCardRecognized.value = true
        message.success('身份证信息识别成功，已自动回填', 3)
      } else {
        // 识别失败，但也标记已尝试识别，允许用户手动输入
        hasIdCardRecognized.value = true
        message.warning(res.msg || '识别失败，请重试', 3)
      }
    })
    .catch((error) => {
      loading()
      console.error('调用百度身份证识别API失败', error)
      // 识别失败，但也标记已尝试识别，允许用户手动输入
      hasIdCardRecognized.value = true
      message.error(
        error.msg || '识别失败，请检查网络连接或稍后重试',
        3
      )
    })
}

const handleEmblemUrlChange = (url) => {
  form.emblemUrl = url
  if (url) {
    hasIdCardRecognized.value = true // 标记已进行身份证识别
    callBaiduIdCardRecognition(url, 'back')
  } else {
    hasIdCardRecognized.value = false // 清除国徽面时，重置识别标记
    form.cardStartTime = undefined
    form.cardEndTime = undefined
  }
}

const disabledDepartDate = (current) => {
  if (!form.entryTime || !current) {
    return false
  }
  const entryTime = moment(form.entryTime, 'YYYY-MM-DD')
  // 禁用入职时间当天及之前的日期
  return current.isBefore(entryTime, 'day')
}

const handleCertificateUrlChange = (data) => {
  if (typeof data === 'object' && data !== null) {
    if (data.certificateUrl !== undefined) {
      form.certificateUrl = data.certificateUrl
    } else if (
      data.certificateUrlArr &&
      Array.isArray(data.certificateUrlArr)
    ) {
      form.certificateUrl = data.certificateUrlArr
        .map((item) => item.url || item.path || item)
        .filter((url) => url)
        .join(',')
    }
  } else if (typeof data === 'string') {
    form.certificateUrl = data
  } else {
    form.certificateUrl = ''
  }
  console.log('机动人才证书URL:', form.certificateUrl)
}

const handleAdd = () => {
  formTitle.value = '新增用户'

  reset()
  // loadAttendanceOptions()

  emit('select-tree')

  form.password = initPassword.value

  visible.value = true

  getProjectUser()
    .then((response) => {
      console.log('获取项目用户数据成功:', response)
      if (response && response.data) {
        postOptions.value = response.data.posts || []
        roleOptions.value = response.data.roles || []
      } else {
        postOptions.value = []
        roleOptions.value = []
      }
      loadAttendanceOptions()
    })
    .catch((error) => {
      console.error('获取项目用户数据失败:', error)
      postOptions.value = []
      roleOptions.value = []
      loadAttendanceOptions()
    })

  console.log('=== handleAdd 结束 ===')
}

const handleUpdate = (row, ids) => {
  reset()
  emit('select-tree')
  const userId = row ? row.id : ids
  getProjectUser(userId).then((response) => {
    Object.assign(form, response.data.data)
    postOptions.value = response.data.posts || []
    roleOptions.value = response.data.roles || []
    if (response.data.roleIds && response.data.roleIds.length) {
      form.roleIds = response.data.roleIds[0]
    } else {
      form.roleIds = ''
    }
    if (form.projectCodes) {
      if (form.projectCodes === '0') {
        isAllProjectSelected.value = true
        selectedProjects.value = []
      } else {
        isAllProjectSelected.value = false
        selectedProjects.value = form.projectCodes
          .split(',')
          .filter((v) => v && v !== '0')
      }
    } else {
      isAllProjectSelected.value = false
      selectedProjects.value = []
    }
    // 如果接口返回了身份证有效期，标记为接口值，应该禁用
    hasIdCardFromApi.value = !!(form.cardStartTime || form.cardEndTime)
    hasIdCardRecognized.value = false // 编辑模式下重置识别标记
    visible.value = true
    formTitle.value = '修改用户'
    form.password = undefined
    handleUserStatusChange(form.userStatus)
    loadAttendanceOptions()
  })
}

const submitForm = () => {
  formRef.value.validate().then(() => {
    submitLoading.value = true
    // 仅构建请求参数，避免污染表单模型导致 roleIds 重复嵌套
    const payload = { ...form }
    payload.roleIds = Array.isArray(form.roleIds)
      ? form.roleIds.flat(Infinity).filter((item) => item !== '' && item !== null && item !== undefined)
      : (form.roleIds !== '' && form.roleIds !== null && form.roleIds !== undefined ? [form.roleIds] : [])
    if (isAllProjectSelected.value) {
      payload.projectCodes = '0'
    } else if (
      selectedProjects.value &&
      selectedProjects.value.length > 0
    ) {
      payload.projectCodes = selectedProjects.value.join(',')
    } else {
      payload.projectCodes = undefined
    }
    payload.chineseName = undefined
    payload.englishName = undefined
    let requestPromise
    if (form.id !== undefined) {
      requestPromise = updateUser(payload)
    } else {
      requestPromise = addUser(payload)
    }

    requestPromise
      .then((response) => {
        // 检查响应状态码，只有 20001 才是成功
        const code = response?.code
        if (code == 20001 || code === 20001 || code === '20001') {
          message.success(form.id !== undefined ? '修改成功' : '新增成功', 3)
          visible.value = false
          emit('ok')
        } else {
          // 失败时显示错误信息
          const errorMsg = response?.message || response?.msg || '操作失败，请稍后重试'
          message.error(errorMsg, 3)
        }
      })
      .catch((error) => {
        // 处理请求异常
        let errorMessage = '操作失败，请稍后重试'
        if (error && error.response && error.response.data) {
          const data = error.response.data
          errorMessage = data.message || data.msg || errorMessage
        } else if (error && error.message) {
          errorMessage = error.message
        }
        message.error(errorMessage, 3)
      })
      .finally(() => {
        submitLoading.value = false
      })
  }).catch(() => {
    return false
  })
}

onMounted(() => {
  getConfigKey('sys.user.initPassword').then((response) => {
    initPassword.value = response.msg
  })
  getProjectList()
})

defineExpose({
  handleAdd,
  handleUpdate,
})
</script>

<style scoped>
.create-form-modal :deep(.ant-modal-body) {
  max-height: 70vh;
  overflow-y: auto;
  padding: 20px 16px !important;
  /* 减少左右内边距 */
}

.bottom-control {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

.create-form-modal :deep(.ant-form-item) {
  margin-bottom: 16px;
}

.create-form-modal :deep(.ant-form-item-label) {
  padding-bottom: 6px;
  flex: 0 0 150px !important;
  /* 减少标签宽度 */
  max-width: 150px !important;
}

/* 两列布局样式 */
.two-column-form :deep(.ant-form-item-label) {
  width: 150px !important;
  min-width: 150px !important;
  max-width: 150px !important;
  text-align: right;
  padding-right: 8px !important;
  /* 减少标签右侧内边距 */
  flex: 0 0 150px !important;
}

.two-column-form :deep(.ant-form-item-label > label) {
  width: 100%;
  text-align: right;
  justify-content: flex-end;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  line-height: 1.5 !important;
  padding-top: 2px !important;
  padding-bottom: 2px !important;
  font-size: 13px !important;
  /* 减小字体大小 */
  letter-spacing: -0.2px;
}

/* 为长标签字段特别处理 */
.two-column-form :deep(.ant-form-item-label:has([for="cardStartTime"]) > label),
.two-column-form :deep(.ant-form-item-label:has([for="cardEndTime"]) > label),
.two-column-form :deep(.ant-form-item-label:has([for="certificateCode"]) > label) {
  font-size: 12.5px !important;
  /* 进一步减小长标签字体大小 */
  letter-spacing: -0.3px;
  padding-right: 2px !important;
}

.two-column-form :deep(.ant-form-item-control) {
  flex: 1;
  min-width: 0;
}

/* 调整输入框宽度 */
.two-column-form :deep(.ant-input),
.two-column-form :deep(.ant-select),
.two-column-form :deep(.ant-picker),
.two-column-form :deep(.ant-tree-select) {
  width: 100%;
  min-width: 180px;
}

/* 图片上传水平居中布局 */
.upload-row {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.upload-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.upload-label {
  margin-bottom: 8px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
}

/* 保存按钮样式 - 使用更具体的选择器确保优先级 */
.create-form-modal .save-btn,
.save-btn {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  border-radius: 4px 4px 4px 4px !important;
}

.create-form-modal .save-btn:hover,
.save-btn:hover {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  opacity: 0.9;
  border-radius: 4px 4px 4px 4px !important;
}

.create-form-modal .save-btn:focus,
.save-btn:focus {
  border-radius: 4px 4px 4px 4px !important;
}

/* 取消按钮样式 - 使用更具体的选择器确保优先级 */
.create-form-modal .cancel-btn,
.cancel-btn {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
  border-radius: 4px 4px 4px 4px !important;
}

.create-form-modal .cancel-btn:hover,
.cancel-btn:hover {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
  border-radius: 4px 4px 4px 4px !important;
}

.create-form-modal .cancel-btn:focus,
.cancel-btn:focus {
  border-radius: 4px 4px 4px 4px !important;
}

/* 输入框样式 - 圆角和边框 */
.two-column-form :deep(.ant-input),
.two-column-form :deep(.ant-input:hover),
.two-column-form :deep(.ant-input:focus),
.create-form-modal :deep(.ant-input),
.create-form-modal :deep(.ant-input:hover),
.create-form-modal :deep(.ant-input:focus) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.two-column-form :deep(.ant-input-affix-wrapper),
.two-column-form :deep(.ant-input-affix-wrapper:hover),
.two-column-form :deep(.ant-input-affix-wrapper-focused),
.create-form-modal :deep(.ant-input-affix-wrapper),
.create-form-modal :deep(.ant-input-affix-wrapper:hover),
.create-form-modal :deep(.ant-input-affix-wrapper-focused) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
.two-column-form :deep(.ant-input-affix-wrapper .ant-input),
.create-form-modal :deep(.ant-input-affix-wrapper .ant-input) {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

/* 密码输入框样式 - 只在外层设置边框 */
.two-column-form :deep(.ant-input-password .ant-input-affix-wrapper),
.create-form-modal :deep(.ant-input-password .ant-input-affix-wrapper) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 密码输入框内部input去掉边框，避免嵌套 */
.two-column-form :deep(.ant-input-password .ant-input),
.create-form-modal :deep(.ant-input-password .ant-input) {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

.two-column-form :deep(.ant-input-password .ant-input-affix-wrapper .ant-input),
.create-form-modal :deep(.ant-input-password .ant-input-affix-wrapper .ant-input) {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

.two-column-form :deep(.ant-select-selector),
.two-column-form :deep(.ant-select-selector:hover),
.two-column-form :deep(.ant-select-focused .ant-select-selector),
.create-form-modal :deep(.ant-select-selector),
.create-form-modal :deep(.ant-select-selector:hover),
.create-form-modal :deep(.ant-select-focused .ant-select-selector) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.two-column-form :deep(.ant-picker),
.two-column-form :deep(.ant-picker:hover),
.two-column-form :deep(.ant-picker-focused),
.create-form-modal :deep(.ant-picker),
.create-form-modal :deep(.ant-picker:hover),
.create-form-modal :deep(.ant-picker-focused) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.two-column-form :deep(.ant-tree-select-selector),
.two-column-form :deep(.ant-tree-select-selector:hover),
.two-column-form :deep(.ant-tree-select-focused .ant-tree-select-selector),
.create-form-modal :deep(.ant-tree-select-selector),
.create-form-modal :deep(.ant-tree-select-selector:hover),
.create-form-modal :deep(.ant-tree-select-focused .ant-tree-select-selector) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.two-column-form :deep(.ant-input-number),
.two-column-form :deep(.ant-input-number:hover),
.two-column-form :deep(.ant-input-number-focused),
.create-form-modal :deep(.ant-input-number),
.create-form-modal :deep(.ant-input-number:hover),
.create-form-modal :deep(.ant-input-number-focused) {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 其他组件保持无圆角 */
.create-form-modal :deep(.ant-select-selection-search),
.create-form-modal :deep(.ant-select-selection-search-input),
.create-form-modal :deep(.ant-select-selection-item),
.create-form-modal :deep(.ant-select-selection-placeholder),
.create-form-modal :deep(.ant-picker-input),
.create-form-modal :deep(.ant-picker-input > input),
.create-form-modal :deep(.ant-picker-input > input:hover),
.create-form-modal :deep(.ant-picker-input > input:focus),
.create-form-modal :deep(.ant-input-number-input),
.create-form-modal :deep(.ant-input-number-input-wrap),
.create-form-modal :deep(.ant-radio-button-wrapper),
.create-form-modal :deep(.ant-radio-button-wrapper:first-child),
.create-form-modal :deep(.ant-radio-button-wrapper:last-child),
.create-form-modal :deep(.ant-radio-button-wrapper-checked),
.create-form-modal :deep(.ant-btn:not(.save-btn):not(.cancel-btn)),
.create-form-modal :deep(.ant-btn:not(.save-btn):not(.cancel-btn):hover),
.create-form-modal :deep(.ant-btn:not(.save-btn):not(.cancel-btn):focus),
.create-form-modal :deep(.ant-btn-primary:not(.save-btn):not(.cancel-btn)),
.create-form-modal :deep(.ant-btn-dashed:not(.save-btn):not(.cancel-btn)),
.create-form-modal :deep(.ant-btn-default:not(.save-btn):not(.cancel-btn)) {
  border-radius: 0 !important;
}

.create-form-modal :deep(.ant-select-dropdown),
.create-form-modal :deep(.ant-picker-dropdown),
.create-form-modal :deep(.ant-tree-select-dropdown),
.create-form-modal :deep(.ant-picker-dropdown-placement-bottomLeft),
.create-form-modal :deep(.ant-picker-dropdown-placement-topLeft) {
  border-radius: 0 !important;
}

.create-form-modal :deep(.ant-select-item),
.create-form-modal :deep(.ant-select-item-option),
.create-form-modal :deep(.ant-picker-panel),
.create-form-modal :deep(.ant-picker-panel-container),
.create-form-modal :deep(.ant-tree-select-tree),
.create-form-modal :deep(.ant-tree-select-tree-node),
.create-form-modal :deep(.ant-picker-header),
.create-form-modal :deep(.ant-picker-body),
.create-form-modal :deep(.ant-picker-content),
.create-form-modal :deep(.ant-picker-cell),
.create-form-modal :deep(.ant-picker-cell-inner) {
  border-radius: 0 !important;
}

.two-column-form :deep(.ant-form-item-control-wrapper) {
  flex: 1;
}

.two-column-form :deep(.ant-row) {
  flex-wrap: nowrap;
}

.two-column-form :deep(.ant-col-12) {
  width: 50%;
  max-width: 50%;
}

/* 减少列之间的间距 */
.two-column-form :deep(.ant-col-12:first-child) {
  padding-right: 6px !important;
}

.two-column-form :deep(.ant-col-12:last-child) {
  padding-left: 6px !important;
}

/* 减少整个表单的左边距 */
.two-column-form :deep(.ant-form-item) {
  margin-left: -8px !important;
  margin-right: -8px !important;
}

/* 或者使用更直接的方式调整整个表单的布局 */
.create-form-modal :deep(.ant-form) {
  padding: 0 4px !important;
}

/* 调整标签对齐，确保不会过于靠右 */
.two-column-form :deep(.ant-form-item-label) {
  margin-right: -4px !important;
}
</style>

<style>
/* 输入框样式 - 圆角和边框 */
.create-form-modal .ant-input,
.create-form-modal .ant-input:hover,
.create-form-modal .ant-input:focus {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.create-form-modal .ant-input-affix-wrapper,
.create-form-modal .ant-input-affix-wrapper:hover,
.create-form-modal .ant-input-affix-wrapper-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
.create-form-modal .ant-input-affix-wrapper .ant-input {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

/* 密码输入框样式 - 只在外层设置边框 */
.create-form-modal .ant-input-password .ant-input-affix-wrapper {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 密码输入框内部input去掉边框，避免嵌套 */
.create-form-modal .ant-input-password .ant-input {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

.create-form-modal .ant-input-password .ant-input-affix-wrapper .ant-input {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

.create-form-modal .ant-select-selector,
.create-form-modal .ant-select-selector:hover,
.create-form-modal .ant-select-focused .ant-select-selector {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.create-form-modal .ant-picker,
.create-form-modal .ant-picker:hover,
.create-form-modal .ant-picker-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.create-form-modal .ant-tree-select-selector,
.create-form-modal .ant-tree-select-selector:hover,
.create-form-modal .ant-tree-select-focused .ant-tree-select-selector {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.create-form-modal .ant-input-number,
.create-form-modal .ant-input-number:hover,
.create-form-modal .ant-input-number-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 其他组件保持无圆角 */
.create-form-modal .ant-picker-input>input,
.create-form-modal .ant-radio-button-wrapper,
.create-form-modal .ant-btn:not(.save-btn):not(.cancel-btn) {
  border-radius: 0 !important;
}
</style>